import { request } from '@/api/client';
import type {
  CreditBalanceResponse,
  CreditPackage,
  PurchaseCreditsRequest,
  PurchaseCreditsResponse,
  CreditTransactionsResponse,
  PricingConfigResponse,
} from '@/types/credits';

/** Service layer for credit balance, packages, purchases, and Stripe checkout. */
export const creditService = {
  getBalance: (): Promise<CreditBalanceResponse> =>
    request<CreditBalanceResponse>('/credits/balance', {
      method: 'GET',
      auth: true,
    }),

  getPackages: (): Promise<CreditPackage[]> =>
    request<CreditPackage[]>('/credits/packages', {
      method: 'GET',
    }),

  purchase: (packageId: string): Promise<PurchaseCreditsResponse> =>
    request<PurchaseCreditsResponse>('/credits/purchase', {
      method: 'POST',
      body: JSON.stringify({ package_id: packageId } as PurchaseCreditsRequest),
      auth: true,
    }),

  getTransactions: (offset = 0, limit = 20): Promise<CreditTransactionsResponse> =>
    request<CreditTransactionsResponse>(
      `/credits/transactions?offset=${encodeURIComponent(offset)}&limit=${encodeURIComponent(limit)}`,
      {
        method: 'GET',
        auth: true,
      }
    ),

  getPricing: (): Promise<PricingConfigResponse> =>
    request<PricingConfigResponse>('/credits/pricing', {
      method: 'GET',
    }),

  createCheckout: (packageId: string): Promise<{ checkout_url: string; session_id: string }> =>
    request<{ checkout_url: string; session_id: string }>('/payments/create-checkout-session', {
      method: 'POST',
      body: JSON.stringify({ package_id: packageId }),
      auth: true,
    }),
};
